import { type ReactElement } from 'react';
import { formatLocalEData } from '@/components/cover/resolve-cover-fields';
import { Psychologist } from '@/types/psychologist';

interface Props {
    full_name?: Psychologist['full_name'];
    crp?: Psychologist['crp'];
    city?: Psychologist['city'];
    state?: Psychologist['state'];
}

/**
 * Fecho do laudo. O "Local, data" sai da mesma função da capa, então as duas
 * páginas do mesmo laudo nunca mostram cidade ou data diferentes.
 */
function PreviewPsychologistSignature({ full_name, crp, city, state }: Props): ReactElement {
    return (
        <div className="mt-8 border-t border-slate-300 pt-4">
            <div className="text-right text-sm text-slate-600">
                <div>{formatLocalEData({ city, state })}</div>
                <div className="mt-4">_____________________________________</div>
                <div className="mt-2">{full_name || 'Nome do Psicólogo'}</div>
                {crp && <div>CRP {crp}</div>}
            </div>
        </div>
    );
}

export default PreviewPsychologistSignature;
